import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import { Topbar } from './components';

import { LOGO_ONLY as theLogo } from '../../constants';

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 20,
    height: '100%',
    background: '#eee',
    margin: 'auto'
  },
  content: {
    background: '#eee',
    margin: 'auto'
  },
  form: {
    background: '#fff'
  },
  contentHeader: {
    display: 'none'
  },
  brandBar: {
      padding: 12,
      background: 'white',
      width: '100%',
      textAlign: 'center',
      borderBottom: '1px solid #e9e9e9',
      position: 'fixed',
      top: 0,

  },
  companyLogo: {
      width: 300,
      margin: 'auto'
  },
  contentMargin: {
      marginTop: 132,
  }
}));

const Minimal = props => {
  const { children } = props;

  const classes = useStyles();

  return (
    // <div className={classes.root}>
  
    //   <main className={classes.content}>{children}</main>
    // </div>
    <>
      <div className={classes.brandBar}>
        <a href='/'>
          <img src={theLogo} alt="Understanding Ag, LLC" className='company-logo' width='150' />
        </a>
        <div style={{ verticalAlign: 'top', paddingTop: 44, color: '#623b17', marginLeft: 2, fontSize: 18, fontWeight: 500, display:'inline-block' }}>
          Understanding<span style={{ fontWeight: 'bold' }}>AG</span>&nbsp;&nbsp;Regen Ag Online Series
        </div>

      </div>

       <div className={classes.contentMargin}>
  
       <main>{children}</main>
     </div>
     </>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Minimal;
